import { render, staticRenderFns } from "./restaurantApprovalTable.vue?vue&type=template&id=8df1eff6&"
import script from "./restaurantApprovalTable.vue?vue&type=script&lang=js&"
export * from "./restaurantApprovalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports